import { useEffect } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { sessionAnalysisApi } from "../api/sessionAnalysisApi";

export function useMeetingAnalysis() {
  return useQuery({
    queryKey: ["meeting_analysis"],
    queryFn: () => sessionAnalysisApi.getAll(),
  });
}

export function useMeetingAnalysisById(id: string) {
  return useQuery({
    queryKey: ["meeting_analysis", id],
    queryFn: () => sessionAnalysisApi.getById(id),
    enabled: !!id,
  });
}

export function useCreateMeetingAnalysis() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => sessionAnalysisApi.insert(data),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ["meeting_analysis"] }),
  });
}

export function useMeetingAnalysisRealtime(
  id: string,
  onChange: (payload: any) => void
) {
  useEffect(() => {
    const subscription = sessionAnalysisApi.subscribeById(id, onChange);
    return () => {
      subscription.unsubscribe();
    };
  }, [id, onChange]);
}

export function useLiveMeetingAnalysis(sessionId: string) {
  const query = useMeetingAnalysisById(sessionId);

  useEffect(() => {
    if (!sessionId) return;
    const subscription = sessionAnalysisApi.subscribeById(sessionId, () => {
      query.refetch();
    });
    return () => {
      subscription.unsubscribe();
    };
  }, [sessionId, query]);

  return query;
}
